import { render, staticRenderFns } from "./ChartComponentG2.vue?vue&type=template&id=4a78c368"
import script from "./ChartComponentG2.vue?vue&type=script&lang=js"
export * from "./ChartComponentG2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a78c368')) {
      api.createRecord('4a78c368', component.options)
    } else {
      api.reload('4a78c368', component.options)
    }
    module.hot.accept("./ChartComponentG2.vue?vue&type=template&id=4a78c368", function () {
      api.rerender('4a78c368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/ChartComponentG2.vue"
export default component.exports